// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.footer[data-v-0a8918a9] {\n\tpadding: 3rem 1.5rem;\n\tfont-size: 0.9em;\n\t/* \n\t\tmethod for pinning footer to bottom of page.\n\t\twill have to come back to this at some point\n\t*/\n\t/* flex-shrink: 0; */\n}\n", ""]);
// Exports
module.exports = exports;
